import { render, staticRenderFns } from "./PalletUsage.vue?vue&type=template&id=554344b0"
import script from "./PalletUsage.vue?vue&type=script&lang=js"
export * from "./PalletUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports